"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _StreamRadio = _interopRequireDefault(require("./StreamRadio"));

var _actions = require("../../../actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function StreamsSelection(_ref) {
  var _ref$indexThreshold = _ref.indexThreshold,
      indexThreshold = _ref$indexThreshold === void 0 ? null : _ref$indexThreshold,
      _ref$showDownload = _ref.showDownload,
      showDownload = _ref$showDownload === void 0 ? true : _ref$showDownload,
      className = _ref.className;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.messageStreams;
  }),
      threshold = _useSelector.threshold,
      personas = _useSelector.personas;

  indexThreshold = indexThreshold ? indexThreshold : threshold;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    return state.quadrants;
  }),
      quadrants = _useSelector2.quadrants,
      current = _useSelector2.current,
      isFetching = _useSelector2.isFetching;

  (0, _react.useEffect)(function () {
    dispatch((0, _actions.getQuadrantMessages)(indexThreshold));
  }, [dispatch, indexThreshold, current]);
  (0, _react.useEffect)(function () {
    var personaIds = personas ? personas.map(function (persona) {
      return persona.id;
    }).join(',') : '';
    dispatch((0, _actions.getPersonaInsights)(personaIds));
  }, [dispatch, personas]);

  var handleRadioChange = function handleRadioChange(e, _ref2) {
    var value = _ref2.value;
    dispatch((0, _actions.setCurrentStream)(value));
  };

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
    className: "message-streams--radio-group " + (className ? className : '')
  }, quadrants && quadrants.sort(function (a, b) {
    return b.percentage - a.percentage;
  }).map(function (stream, i) {
    return stream.percentage > 0 && /*#__PURE__*/_react["default"].createElement(_StreamRadio["default"], {
      key: i,
      stream: stream,
      currentStream: current,
      indexThreshold: indexThreshold,
      isFetching: isFetching,
      handleRadioChange: handleRadioChange,
      showDownload: showDownload
    });
  }));
}

var _default = StreamsSelection;
exports["default"] = _default;